<div 
  [class.flex-center-space-between]="!showSearch">
  @if (!showSearch) {
    <div class="flex items-center">
    <span>
      {{title}}
    </span>
  </div>
  }
  <div class="centered-row-container">
    @if (!showSearch) {
      <app-all-icons
        [iconNameAndStyling]="'search.svg; clickable'"
        (click)="showSearch = true"/>
    }
    @else {
    <div class="centered-row-container absolute position-for-search">
      <app-input class="input-wrapper flex-grow-1 "
        [isShrinked]="true"
        [autofocus]="true"
        [placeholder]="placeholder"
        [formControl]="searchControl"
        [prefixFirstIcon]="'search.svg'"
        [suffixFirstIcon]="'close.svg'"
        (suffixFirstIconEmitter)="cancel()"/>
  </div>
}
</div>